import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { PACK_IMAGE } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b border-line bg-canvasAlt" data-id="element-94" data-mp="4lqj4w64bd3i">
      <div className="mx-auto max-w-3xl px-4 pt-6 pb-8 text-center sm:px-6 sm:pt-8" data-id="element-95" data-mp="4n9z0lnv3m4r">
        <motion.p initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="inline-flex items-center gap-1.5 rounded-full border border-accent/40 bg-accent-soft px-3 py-1 font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-96" data-mp="1285ztvqq06q0">
          <ZapIcon size={12} data-id="element-97" data-mp="3d1a8hk3o4bda" />
          Método práctico y organizado
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-3 font-display text-xl font-black leading-tight text-ink sm:text-3xl" data-id="element-98" data-mp="382fdzkwc8ydc">
          El Sistema Completo para{' '}
          <span className="text-accent" data-id="element-99" data-mp="39al8ybyf2k23">Aprender Electrónica</span> y Llevarla a
          la Práctica
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.08
      }} className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-ink-muted sm:text-base" data-id="element-100" data-mp="3e8mqutk3wdbz">
          Ahorrá horas buscando información, avanzá con claridad y convertí lo
          que aprendés en proyectos reales — sin perderte entre cientos de
          tutoriales y PDFs.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.12
      }} className="mt-4 inline-block rounded-lg bg-accent px-4 py-2 font-display text-xs font-extrabold uppercase tracking-wide text-canvas sm:text-sm" data-id="element-101" data-mp="2hjf8tvip4mct">
          Mega Pack Electrónica para Emprender — Sistema 6 en 1
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.16
      }} className="mt-4 rounded-2xl border border-line bg-surface p-2 sm:p-3" data-id="element-102" data-mp="id9v0gzmuhve">
          <img src={PACK_IMAGE} alt="Mega Pack Electrónica para Emprender: 6 tomos y bonos con componentes, soldadura, diagnóstico, reparación y proyectos" className="mx-auto w-full" data-id="element-103" data-mp="1622jjsdxdnfz" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.2
      }} className="mt-4" data-id="element-104" data-mp="x0l328wlvjqr">
          <CtaButton href="#oferta" size="lg" data-id="element-105" data-mp="3hq26kygu48ad">
            Sí, quiero mi Mega Pack ahora
          </CtaButton>

          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[0.7rem] text-ink-muted sm:text-xs" data-id="element-106" data-mp="1x7869rdijxvp">
            <span className="flex items-center gap-1.5" data-id="element-107" data-mp="269hegalb7f5x">
              <StarIcon size={13} className="fill-accent text-accent" data-id="element-108" data-mp="267whkebivk4w" />
              Acceso inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-109" data-mp="2fzss4ousp2q0">•</span>
            <span className="flex items-center gap-1.5" data-id="element-110" data-mp="2fz0znmwhvl3y">
              <ShieldCheckIcon size={13} className="text-success" data-id="element-111" data-mp="2kynd9xg8j3da" />
              Garantía 7 días — Cero riesgo
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}